import { render, staticRenderFns } from "./ItemProductList.vue?vue&type=template&id=7ac7051c&"
import script from "./itemproductlist.js?vue&type=script&lang=js&"
export * from "./itemproductlist.js?vue&type=script&lang=js&"
import style0 from "./ItemProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports